import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

const LandingRoute = () => (
  <ReactLenis root options={{ lerp: 0.085, smoothWheel: true }}>
    <Landing />
  </ReactLenis>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingRoute />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid rgba(227,30,36,0.4)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
